import { observer } from 'mobx-react';
import React, { useState } from 'react';

import {
	FormControl,
	FormControlLabel,
	Grid,
	Link,
	Paper,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import store from 'store';

import { ILoginData } from '@common/api/auth';
import { ROUTES } from '@common/constants/CampusRoutes';

import Layout from '../components/Layout';
import LoginForm from './Form';
import schema, { LoginFormValues } from './schema';

function Login() {
	const [isSeveralAccounts] = useState(false);

	const handleSubmit = async (values: ILoginData) => {
		try {
			await store.auth.login({ ...values, remember: undefined } as ILoginData, true);
			// if (result?.isSeveralAccounts) {
			// 	setIsSeveralAccounts(true);
			// }
		} catch (e) {
			console.error('Sign in Error', e);
			throw e;
		}
	};

	return isSeveralAccounts ? (
		<Paper
			sx={{
				p: '32px',
				borderRadius: '32px',
				mx: '10px',
			}}
		>
			<FormControl component="fieldset">
				<Grid container flexDirection="column" gap={3}>
					<Typography variant="h2" align="center">
						Select the child's account
					</Typography>
					<RadioGroup>
						<Grid display="flex" flexDirection="column" gap={2}>
							<Paper elevation={10} sx={{ pl: '10px' }}>
								<FormControlLabel
									sx={{ width: '100%' }}
									value="Zalilo Danil"
									control={<Radio />}
									label="Zalilo Danil"
								/>
							</Paper>
							<Paper elevation={10} sx={{ pl: '10px' }}>
								<FormControlLabel
									sx={{ width: '100%' }}
									value="Zalilo Sofia"
									control={<Radio />}
									label="Zalilo Sofia"
								/>
							</Paper>
						</Grid>
					</RadioGroup>
				</Grid>
			</FormControl>
		</Paper>
	) : (
		<Layout<LoginFormValues>
			header="Login"
			headerText="Enter your email and password to log in "
			buttonText="Log in"
			initialValues={{
				email: '',
				password: '',
				remember: false,
			}}
			onSubmit={handleSubmit}
			validationSchema={schema()}
			footer={
				<Link borderBottom="none" href={ROUTES.RESET_PASSWORD}>
					<MediaTypography variant="body2" textAlign="center" color="primary.main">
						Forgot your password
					</MediaTypography>
				</Link>
			}
		>
			<LoginForm />
		</Layout>
	);
}

export default observer(Login);
